import { Loading } from 'element-ui';

import { getMenusList, listMenuButtons } from '@/api/common/user';
export const IS_PERMISSION_BUTTON = 'permission/isPermissionButton';

const handleAggregateMerchantMenus = (menus) => {
  // 确认最外层是收单还是付款
  const businessTypeMapper = {
    bigAcquiring: 'acq',
    bigPayout: 'payout',
  };

  // 需要配合聚合商户整改的页面
  const deepLevelChildrenMenusNode = ['index', 'wallet:balance', 'transfer:transfer', 'transfer:contact'];
  // 深层遍历处理菜单节点
  const traverseMenus = (node, parentCode) => {
    // 用于跟踪已经匹配过的节点类型
    const matchedTypes = new Set();

    // 如果当前节点是需要处理的二级菜单节点，并且该类型尚未匹配过
    if (deepLevelChildrenMenusNode.includes(node.resourceCode) && !matchedTypes.has(node.resourceCode)) {
      // 在父级节点中找到对应的业务类型映射
      if (parentCode && businessTypeMapper[parentCode]) {
        node.menuUrl += `/aggregate/${businessTypeMapper[parentCode]}`;
        // 标记该类型已匹配
        matchedTypes.add(node.resourceCode);
      }
    }

    // 如果有子节点，继续递归处理
    if (node.childrenNode && node.childrenNode.length > 0) {
      node.childrenNode = node.childrenNode.map(child =>
        traverseMenus(child, node.resourceCode === 'bigAcquiring' || node.resourceCode === 'bigPayout' ? node.resourceCode : parentCode),
      );
    }

    return node;
  };

  // 对顶层菜单进行遍历处理
  return menus.map(item => traverseMenus(item, null));
};

export default {
  namespaced: true,
  state: ({
    menus: [], // 菜单
    permissionCodes: [], // 页面的按钮权限,resourceCode
    pageIds: [], // 页面Id
  }),
  mutations: {
    setMenus: (state, menus) => {
      state.menus = menus;
    },
    setPages: (state, permission) => {
      state.permissionCodes = [...state.permissionCodes, ...permission];
    },
    setPageId: (state, page) => {
      if (!state.pageIds.includes(page)) {
        state.pageIds.push(page);
      }
    },
  },

  actions: {
    getMenus: async ({ commit, state, rootState }, data = { showLoading: true, refresh: false }) => {
      if (!state.menus.length || (data && data.refresh)) {
        let loading;
        if (data && data.showLoading) {
          loading = Loading.service();
        }
        await getMenusList().then((res) => {
          const { isAggregateMerchant } = rootState.app.userLogin;
          let menus = [...res];

          // 聚合商户，重新处理菜单数据
          if (isAggregateMerchant) {
            menus = handleAggregateMerchantMenus(menus);
          }
          commit('setMenus', menus);

          loading && loading.close();
        }).catch(() => {
          loading && loading.close();
        });
      }
    },
    getPages: async ({ commit, state }, pageId) => {
      if (!state.pageIds.includes(pageId)) {
        const loading = Loading.service();
        await listMenuButtons(pageId).then((res) => {
          commit('setPageId', pageId);
          commit('setPages', res);
          loading.close();
        }).catch(() => {
          loading.close();
        });
      }
    },
    setPages: ({ commit }, data) => {
      commit('setPageId', data.pageId);
      commit('setPages', data.permission);
    },
  },
  getters: {
    isPermissionButton(state) {
      return (value) => {
        if (state.permissionCodes) {
          if (state.permissionCodes.includes(value)) {
            return true;
          }
        }
        return false;
      };
    },
  },
};
